var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var OkDialogModal = require('../common/ok-message-dialog-with-action');

var ResendConfirmationLinkView = Marionette.View.extend({
    template: require('../../templates/persons/resend-confirmation-link-modal-view.html'),

    regions: {
        inform: '#inform'
    },

    ui: {
        modal: '#resend-confirmation-link-modal',
        send: '#send-confirmation-link',
        email: '#email',
        login: '#login'
    },

    events: {
        'click @ui.send': 'onSend',
        'keyup @ui.login': 'validate',
        'keyup @ui.email': 'validate'
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        that.show();
        that.validate();
    },

    onSend: function () {

        var that = this;
        that.utils.showSpinner("#resend-confirmation-link-loader");

        $.ajax({
            type: "POST",
            url: '/api/utility/send/confirmation-link/' + that.ui.login.val(),
            data: that.ui.email.val(),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner("#resend-confirmation-link-loader");

                    that.informWindow = new OkDialogModal({
                        title: 'Information',
                        message: "Confirmation link was send on email provided. Please click on the link to activate your account",
                        action: function() {
                            that.hide();
                        }
                    });

                    that.showChildView('inform', that.informWindow);
                    that.informWindow.show();
                }
            },
            error: function(e) {
                that.utils.hideSpinner("#resend-confirmation-link-loader");
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    show: function() {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function() {
        this.ui.modal.modal('hide');
    },

    validate: function() {
        var email = this.ui.email.val();
        var login = this.ui.login.val();

        if (!_.isEmpty(email) && this.utils.isValidEmail(email)) {
            this.clearError(this.ui.email);
        } else {
            this.showError(this.ui.email, "Empty or invalid email");
        }

        if (!_.isEmpty(login)) {
            this.clearError(this.ui.login);
        } else {
            this.showError(this.ui.login, "Empty login");
        }

        if (!_.isEmpty(email) && this.utils.isValidEmail(email) && !_.isEmpty(login))
            this.enableSendButton();
        else
            this.disableSendButton();
    },

    enableSendButton: function () {
        this.ui.send.removeAttr('disabled');
    },

    disableSendButton: function () {
        this.ui.send.attr('disabled', true);
    },

    showError: function (jQelement, text) {
        jQelement.tooltip({title: text});
        jQelement.parent().parent().addClass('has-error has-feedback');
    },

    clearError: function (jQelement) {
        jQelement.tooltip("destroy");
        jQelement.parent().parent().removeClass('has-error has-feedback');
    }
});

module.exports = ResendConfirmationLinkView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/resend-confirmation-link-modal-view.js
// module id = 341
// module chunks = 0